import { useFormContext, useFormField } from '@calendly/form';
import { CurrencyField } from '@calendly/ui/form/currency-field';
import { cx } from '@linaria/core';
import { useCallback, useEffect } from 'react';

// CurrencyInput draws the composite border, but nested TextInput focus/invalid
// borders win on specificity and show as a double outline on focus.
const currencyFieldCss = "c857kya";
export const FormCurrencyField = ({
  amountFieldName = 'amount',
  currencyFieldName = 'currency',
  onCurrencyChange: onCurrencyChangeProp,
  id,
  className,
  ...props
}) => {
  const {
    setFieldValue,
    setFieldTouched
  } = useFormContext();
  const [{
    value: amountValue
  }, {
    error: amountError
  }] = useFormField({
    name: amountFieldName
  });
  const [{
    value: currencyValue
  }] = useFormField({
    name: currencyFieldName
  });
  useEffect(() => {
    const hasAmount = amountValue !== undefined && amountValue !== null && amountValue !== '';
    if (hasAmount) {
      setFieldTouched(amountFieldName, true);
    }
  }, [amountValue, amountFieldName, setFieldTouched]);
  const handleAmountChange = useCallback(value => {
    setFieldValue(amountFieldName, value);
    setFieldTouched(amountFieldName, true);
  }, [amountFieldName, setFieldValue, setFieldTouched]);
  const handleCurrencyChange = useCallback(value => {
    setFieldValue(currencyFieldName, value);
    setFieldTouched(currencyFieldName, true);
    if (onCurrencyChangeProp) {
      onCurrencyChangeProp(value);
    }
  }, [currencyFieldName, setFieldValue, setFieldTouched, onCurrencyChangeProp]);
  return <CurrencyField id={id || 'payment-amount-field'} className={cx(currencyFieldCss, className)} value={amountValue} currency={currencyValue} error={amountError} onChange={handleAmountChange} onCurrencyChange={handleCurrencyChange} {...props} />;
};

require("./form_currency_field.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./form_currency_field.js");